export default {
  verification: {
    path: "/verification",
    name: "verification",
  },
};
